// when-visible.js  v3 Nov 2023 - VANILLA !


// Function to initialize when-visible logic
function initializeWhenVisible() {
    const DEV = 0;

    const elements = document.querySelectorAll('[when-visible]');
    
    const options = {
        // root: $(window),
        // rootMargin: "25px",
        threshold: [0.1]
    };

    const observer = new IntersectionObserver(onChange, options);

    elements.forEach(element => {
        observer.observe(element);
    });

    function onChange(changes) {
        changes.forEach(change => {
            DEV && log('change', change);

            const el = change.target;
            DEV && log('el', el);

            if (change.intersectionRatio > 0.1) {
                DEV && log('Item visible');

                el.classList.remove('not-visible');

                const whenVisible = el.getAttribute('when-visible');
                
                switch (whenVisible) {
                    case 'fade':
                        el.classList.add('fade-in-when-visible');
                        break;
                    case 'scale':
                        el.classList.add('scale-in-when-visible');
                        break;
                    case 'up':
                        el.classList.add('up-when-visible');
                        break;
                    case 'down':
                        el.classList.add('down-when-visible');
                        break;
                    case 'left':
                        el.classList.add('left-when-visible');
                        break;
                    case 'right':
                        el.classList.add('right-when-visible');
                        break;
                    case 'width':
                        el.classList.add('width-when-visible');
                        break;
                    case 'discover':
                        el.classList.add('discover-when-visible');
                        break;
                    case 'custom':
                        el.classList.add('vw-when-visible');
                        break;

                    // Add other cases as needed
                    default:
                        // Handle default case or do nothing
                        break;
                }

                observer.unobserve(el);
            }
        });
    }
};


// Initial call on page load
document.addEventListener('DOMContentLoaded', initializeWhenVisible);




// Initial call on page load
document.addEventListener('DOMContentLoaded', function() {
    initializeWhenVisible();

    // Use Mutation Observer to detect changes in the DOM
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            // Check if nodes were added to the DOM
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Call initializeWhenVisible for the new content
                initializeWhenVisible();
            }
        });
    });

    // Start observing the entire document and its descendants
    observer.observe(document, { childList: true, subtree: true });
});






